import type { ReactNode } from 'react';

export const symbol_timer_5: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M528-281q23 0 41.5-13.5T588-331v-90q0-23-18.5-36.5T528-471h-95v-70h125q13 0 21.5-8.5T588-571q0-13-8.5-21.5T558-601H403q-13 0-21.5 8.5T373-571v130q0 13 8.5 21.5T403-411h125v70H403q-13 0-21.5 8.5T373-311q0 13 8.5 21.5T403-281h125Zm164.5 52.5Q780-316 780-441t-87.5-212.5Q605-741 480-741t-212.5 87.5Q180-566 180-441t87.5 212.5Q355-141 480-141t212.5-87.5ZM480-440Zm-90-420q-13 0-21.5-8.5T360-890q0-13 8.5-21.5T390-920h180q13 0 21.5 8.5T600-890q0 13-8.5 21.5T570-860H390Zm-49.5 750.5Q275-138 226-187t-77.5-114.5Q120-367 120-441t28.5-139.5Q177-646 226-695t114.5-77.5Q406-801 480-801q67 0 126 22.5T711-716l30-30q9-9 21-9t21 9q9 9 9 21t-9 21l-30 30q36 40 61.5 97T840-441q0 74-28.5 139.5T734-187q-49 49-114.5 77.5T480-81q-74 0-139.5-28.5Z"
		/>
	</svg>
);
